import { useEffect, useState } from 'react';
import type { AdminApi, Environment } from '../api';
import { orderedReleaseKeys } from '../components/reward-presentation';

export function useClientRelease(api: AdminApi, gameId: string, environment: Environment) {
  const scope = `${gameId}:${environment}`;
  const [state, setState] = useState({ scope: '', keys: [] as string[], selected: '', error: '' });
  const [attempt, retry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setState({ scope: '', keys: [], selected: '', error: '' });
    api.versions(gameId, environment).then(result => {
      if (cancelled) return;
      if (!result.clientReleaseKeys) throw new Error('管理 API 尚未提供客户端版本列表，请先更新服务后重试。');
      const keys = orderedReleaseKeys(result.clientReleaseKeys);
      setState({ scope, keys, selected: keys[0] ?? '', error: keys.length ? '' : '当前环境暂无已配置的客户端版本，请先在发布中心登记版本。' });
    }).catch(error => { if (!cancelled) setState({ scope, keys: [], selected: '', error: error instanceof Error ? error.message : '客户端版本读取失败' }); });
    return () => { cancelled = true; };
  }, [api, gameId, environment, attempt]);
  return {
    releaseKey: state.scope === scope ? state.selected : '',
    releaseKeys: state.scope === scope ? state.keys : [],
    releaseError: state.scope === scope ? state.error : '',
    retryReleases: () => retry(value => value + 1),
    setReleaseKey: (selected: string) => setState(value => value.keys.includes(selected) ? { ...value, selected } : value),
  };
}
